import Vue from 'vue'
import TokenService from '../helpers/token'
import store from '@/store'
import { KHO_M } from '../helpers/constants';

Vue.mixin({
  methods: {
    checkAuthorization (role) {
      const roles = TokenService.getPermissions();

      if (roles.includes(role)) {
        return true
      } else {
        const permissions = store.state.permissions

        if (permissions.includes(role)) {
          return true
        }
      }

      return false
    },
    showInSidebar (roles, titleItem) {
      if (roles === 'all') {
        return true
      } else {
        const userPermissions = TokenService.getPermissions();
        const permissions = store.state.permissions
        if (_.intersection(roles, userPermissions).length
          || _.intersection(roles, permissions).length) {

            // Ẩn Menu Gia sư ở Module khác
            if(['Vận hành gia sư', 'GIA SƯ'].includes(titleItem) && this.$store.state.module.typeId != '' && this.$store.state.module.typeId != 2) {
              return false
            }
            return true
          }
      }

      return false;
    },
    checkConditionT4NT5 (type) {
      if (['T4', 'T5', 'C4', 'C5'].includes(type)) {
        if (this.checkAuthorization('contact_move_to_cc_read')) {
          return true
        } 
        return false
      }
      return true
    },
    checkIncludesT4NT5 (type) {
      if (['T4', 'T5', 'C4', 'C5'].includes(type)) {
        return true
      }
      return false
    },
    checkUserInDepartmentType (type) {
      const user = TokenService.getUser();
      return user.departmentType && user.departmentType == type ? true : false;
    },
    checkConditionT4NT5ForChangeStore (type) {
      if (['T4', 'T5', 'C4', 'C5'].includes(type)) {
        if (this.checkAuthorization('contact_change_store_read')) {
          return true
        }
        return false
      }
      return true
    },
    checkNotIncludesM (type) {
      return !KHO_M.includes(type)
    },
  },
})
